import React from 'react';
import { AppService } from '@aperza/util';
import style from './NavigationHeader.module.scss';
import { useAperzaUserContext } from '../AperzaUserContext';
import { addUtmParam } from '../../addUtmParam';
const serverHost = AppService.tvServerHost();
const TvLocalNavigation = () => {
    const { serviceType } = useAperzaUserContext();
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { href: addUtmParam(`${serverHost}/watch/ondemand/p/1`, 'header', serviceType) }, "\u52D5\u753B\u4E00\u89A7"),
        React.createElement("a", { href: addUtmParam(`${serverHost}/search/webinar?k=展示会レポート`, 'header', serviceType) }, "\u5C55\u793A\u4F1A\u52D5\u753B"),
        React.createElement("a", { href: addUtmParam(`${serverHost}/upcoming`, 'header', serviceType) }, "\u914D\u4FE1\u4E88\u5B9A"),
        React.createElement("a", { href: addUtmParam(`${serverHost}/search/feature?k=ランキング`, 'header', serviceType) }, "\u30E9\u30F3\u30AD\u30F3\u30B0"),
        React.createElement("a", { href: addUtmParam(`${serverHost}/event/event/p/1`, 'header', serviceType) }, "\u30A4\u30D9\u30F3\u30C8"),
        React.createElement("a", { href: addUtmParam(`${serverHost}/event/feature/p/1`, 'header', serviceType) }, "\u7279\u96C6"),
        React.createElement("span", { className: style.navbarDivider }),
        React.createElement("a", { href: addUtmParam('https://lp.aperza.com/tv-registration-001?ref=site_header', 'header', serviceType), target: "_blank" }, "\u63B2\u8F09\u3054\u5E0C\u671B\u306E\u65B9")));
};
export default TvLocalNavigation;
